import { PaymentCycle } from '../../enums';
import {
  Cycle,
  CycleType,
  DurationUnit,
} from '@wix/ambassador-premium-asset-v2-premium-asset/types';

const paymentCycleToCycleMap: { [key in PaymentCycle]: Cycle } = {
  [PaymentCycle.MONTHLY]: {
    cycleType: CycleType.RECURRING,
    cycleDuration: {
      unit: DurationUnit.MONTH,
      count: 1,
    },
  },
  [PaymentCycle.QUARTERLY]: {
    cycleType: CycleType.RECURRING,
    cycleDuration: {
      unit: DurationUnit.MONTH,
      count: 3,
    },
  },
  [PaymentCycle.YEARLY]: {
    cycleType: CycleType.RECURRING,
    cycleDuration: {
      unit: DurationUnit.YEAR,
      count: 1,
    },
  },
  [PaymentCycle.YEAR2]: {
    cycleType: CycleType.RECURRING,
    cycleDuration: {
      unit: DurationUnit.YEAR,
      count: 2,
    },
  },
  [PaymentCycle.YEAR3]: {
    cycleType: CycleType.RECURRING,
    cycleDuration: {
      unit: DurationUnit.YEAR,
      count: 3,
    },
  },
  [PaymentCycle.YEAR4]: {
    cycleType: CycleType.RECURRING,
    cycleDuration: {
      unit: DurationUnit.YEAR,
      count: 4,
    },
  },
  [PaymentCycle.YEAR5]: {
    cycleType: CycleType.RECURRING,
    cycleDuration: {
      unit: DurationUnit.YEAR,
      count: 5,
    },
  },
};

export function paymentCycleToCycle(paymentCycle: PaymentCycle): Cycle {
  return (
    paymentCycleToCycleMap[paymentCycle] || {
      cycleType: CycleType.UNKNOWN_TYPE,
    }
  );
}
